/*global _,window,$ */

'use strict';

angular.module('shopspace.admin', [
  'pascalprecht.translate',
  'ngAnimate',
  'ngCookies',
  'ngSanitize',
  'restangular',
  'ui.router',
  'flow',
  'ui.checkbox',
  'jcs-autoValidate',
  'angular-growl',
  'ui.bootstrap',
  'ui.bootstrap.datetimepicker',
  'angular-loading-bar',
  'ngTagsInput',
  'dialogs.main',
  'xenon',
  'cgBusy',
  'monospaced.elastic',
  'ngMap',
  'ui.bootstrap.popover',
  'quill.editor',

  /*'ui-router-logger',*/

  'shopspace.config',
  'shopspace.directives',
  'shopspace.import',
  'shopspace.orders',
  'shopspace.orders.order',
  'shopspace.wms',
  'shopspace.wms.orderTask',
  'shopspace.wms.skuStock',
  'shopspace.wms.outOfStock',
  'shopspace.wms.fulfilmentTask',
  'shopspace.crm',
  'shopspace.crm.profile',
  'shopspace.catalog',
  'shopspace.catalog.product',
  'shopspace.catalog.productView',
  'shopspace.catalog.sku',
  'shopspace.catalog.category',
  'shopspace.catalog.brand',
  'shopspace.catalog.brandView',
  'shopspace.catalog.additionalOrderService',
  'shopspace.catalog.productGroup',
  'shopspace.catalog.description',
  'shopspace.catalog.facet',
  'shopspace.catalog.fulfilmentGroup',
  'shopspace.marketing',
  'shopspace.marketing.discount',
  'shopspace.marketing.discountCode',
  'shopspace.marketing.discountGroup',
  'shopspace.marketing.productsSet',
  'shopspace.marketing.valueCalculation',
  'shopspace.marketing.productListCategory',
  'shopspace.marketing.globalProductList',
  'shopspace.location',
  'shopspace.location.branch',
  'shopspace.location.warehouse',
  'shopspace.location.criteria',
  'shopspace.location.criteriaValue',
  'shopspace.management',
  'shopspace.management.deliverySlot',
  'shopspace.management.delivery',
  'shopspace.management.deliveryView',
  'shopspace.management.payment',
  'shopspace.management.paymentView',
  'shopspace.management.pricePerValue',
  'shopspace.management.role',
  'shopspace.management.user',
  'shopspace.cms',
  'shopspace.cms.displaySection',
  'shopspace.cms.displayPage',
  'shopspace.cms.displayComponent',
  'shopspace.cms.displayTemplate',
  'shopspace.cms.displayGroup',
  'shopspace.cms.static',
  'shopspace.reportViewer',
  'shopspace.report'
])
  .config(
    function ($stateProvider, $urlRouterProvider, $locationProvider, RestangularProvider, cfpLoadingBarProvider, growlProvider, $translateProvider,
              flowFactoryProvider, appConfig) {

      $locationProvider.html5Mode(true).hashPrefix('!');

      growlProvider.globalTimeToLive({success: 2000, error: 3000, warning: 3000, info: 4000});

      $stateProvider
        .state('app', {
          url: '/app',
          template: '<div ui-view></div>',
          abstract: true
        });

      RestangularProvider.setBaseUrl('/api');
      RestangularProvider.setDefaultHttpFields({
        withCredentials: true
      });

      RestangularProvider.addResponseInterceptor(function (data, operation) {
        var extractedData;
        // .. to look for getList operations
        if (operation === 'getList' && !angular.isArray(data)) {
          // .. and handle the data and meta data
          extractedData = data.content ? data.content : [];
          extractedData.meta = {
            pageNumber: data.pageNumber,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages
          };
        } else {
          extractedData = data;
        }
        return extractedData;
      });

      RestangularProvider.setResponseExtractor(function (response) {
        var newResponse = response;
        if (response) {
          if (angular.isObject(response)) {
            newResponse.originalElement = angular.copy(response);
          }
        }
        return newResponse;
      });

      flowFactoryProvider.defaults = {
        target: '/api/upload',
        testChunks: false,
        chunkSize: 20000000,
        permanentErrors: [404, 500, 501],
        simultaneousUploads: 1,
        allowDuplicateUploads: false
      };

      $translateProvider.translations('pl', {
        DIALOGS_ERROR: 'Błąd',
        DIALOGS_ERROR_MSG: 'Wystąpił nieznany błąd.',
        DIALOGS_CLOSE: 'Zamknij',
        DIALOGS_PLEASE_WAIT: 'Proszę czekać',
        DIALOGS_PLEASE_WAIT_ELIPS: 'Proszę czekać...',
        DIALOGS_PLEASE_WAIT_MSG: 'Proszę czekać na wykonanie operacji.',
        DIALOGS_PERCENT_COMPLETE: '%',
        DIALOGS_NOTIFICATION: 'Informacja',
        DIALOGS_NOTIFICATION_MSG: 'Nieznana informacja.',
        DIALOGS_CONFIRMATION: 'Potwierdzenie',
        DIALOGS_CONFIRMATION_MSG: 'Potwierdzenie wymagane.',
        DIALOGS_OK: 'OK',
        DIALOGS_YES: 'Tak',
        DIALOGS_NO: 'Nie'
      });

      $translateProvider.preferredLanguage('pl');

      $urlRouterProvider.otherwise('/app/orders/order');
    })
  .run(function ($rootScope, $state, $stateParams, Restangular, $window, defaultErrorMessageResolver, validator, emptyModifier, datetimePickerModifier,
                 customMessageModifier, dialogs, appConfig, $http, menuVph, permissionService, $sce, $timeout) {

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.layoutOptions = {
      horizontalMenu: {
        minimal: true,
        isFixed: true
      }
    };
    $rootScope.appConfig = appConfig;

    $rootScope.safeHtml = function (html) {
      return $sce.trustAsHtml(html);
    };

    Restangular.setErrorInterceptor(function (response) {
      if (response.status === 401) {
        $window.location.href = '/login.html';
        return false; // error handled
      }
      if (response.status === 403) {
        dialogs.error(undefined, 'Nie masz wystarczających uprawnień do wykonania tej operacji!');
        return false; // error handled
      }
      if (response.status === 409) {
        dialogs.error(undefined, 'Dane zostały zmodyfikowane przez kogoś innego, odśwież widok i spróbuj ponownie.');
      }
      if (response.status === 500) {
        dialogs.error(undefined, 'Wewnętrzny błąd serwera, skontaktuj się z administratorem<br>' + response.data);
      }

      return true; // error not handled
    });

    defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
      errorMessages.required = 'Pole wymagane';
      errorMessages.editable = 'Wartość musi być wybrana z pola podpowiedzi';
      errorMessages.pattern = 'Nieodpowiedni format';
      errorMessages.unique = 'Wartość musi być unikalna, a ta istnieje już w bazie';
      errorMessages.minlength = 'Minimalna długość to {0} znaków';
      errorMessages.maxlength = 'Maksymalna długość to {0} znaków';
      errorMessages.max = 'Maksymalna wartość to {0}';
      errorMessages.min = 'Minimalna wartość to {0}';
      errorMessages.esmaboOrdersTo = 'Wartość musi być większa niż Zamówienia od';
      errorMessages['invalid-number'] = 'Nieprawidłowa wartość liczbowa';
    });

    validator.setValidElementStyling(false);
    validator.registerDomModifier(emptyModifier.key, emptyModifier);
    validator.registerDomModifier(datetimePickerModifier.key, datetimePickerModifier);
    validator.registerDomModifier(customMessageModifier.key, customMessageModifier);

    $rootScope.logout = function () {
      $http.post('/api/logout').success(function () {
        window.location = '/login.html';
      }).error(function () {
        window.location = '/login.html';
      });
    };

    permissionService.user().then(function () {
      angular.forEach(menuVph, function (val) {
        permissionService.hasActionPermission(val.permissionType, 'VIEW').then(function (res) {
          val.vph.show = res;
          if (val.vph.parent && res) {
            val.vph.parent.show = res;
          }
        });
      });
    });

    $rootScope.scrollToFixed = {
      marginTop: function () {
        var marginTop = $(window).height() - $('#details').outerHeight(true) - 20;
        if (marginTop >= 0) {
          return 20;
        }
        return marginTop;
      }
    };

    $rootScope.$on('$stateChangeSuccess', function () {
      $timeout(function () {
        $(window).scrollTop(0, 0);
      });
    });

    function parseClipboard($event, text, wild, options, tagList) {
      if (/\r|\n/.exec(text)) {
        text = text.replace(/(\r\n|\r|\n)/g, (wild ? '*' : '') + '\n').replace(/\n$/, '');
      }
      if (wild && !text.endsWith('*')) {
        text += '*';
      }
      addTags(text, options, tagList);
    }

    function addTags(data, options, tagList) {

      var tags = data.split(options.pasteSplitPattern);

      tags.forEach(function (tag) {
        tagList.addText(tag);
      });
    }

    $rootScope.pasteNgTags = function ($event, options, tagList) {
      if (options.addOnPaste) {
        var clipboardData = $event.originalEvent.clipboardData || window.clipboardData;
        var text = clipboardData.getData('text/plain');
        $event.stopPropagation();
        $event.preventDefault();

        if (String(options.pasteSplitPattern) === String(/\n/)) {
          dialogs.confirm('', 'Wyszukiwanie z dopełnieniem?').result.then(
            function () {
              parseClipboard($event, text, true, options, tagList);
            },
            function () {
              parseClipboard($event, text, false, options, tagList);
            });
        } else {
          addTags(text, options, tagList);
        }
      }
    };
  })
  .factory('permissionService', function ($q, Restangular, $rootScope) {

    var userDefer = $q.defer();
    var userPromise = userDefer.promise;
    var isAdmin = false;
    var user;

    Restangular.one('users', 'me').get().then(function (resUser) {
      user = resUser;
      isAdmin = _.includes(user.allRolesNames, 'ADMIN');
      $rootScope.user = resUser;
      userDefer.resolve(user);
    });

    var hasActionPermission = function (type, permission) {

      if (isAdmin) {
        return true;
      }
      if (angular.isUndefined(user.allActionPermissions) || angular.isUndefined(user.allActionPermissions[type])) {
        return false;
      }
      var val = _.includes(user.allActionPermissions[type], permission);
      if (!val && permission === 'VIEW') {
        val = _.includes(user.allActionPermissions[type], 'READ_ALL');
      }
      return val;
    };

    var getObjectPermissions = function (type, objectId) {

      var u = hasActionPermission(type, 'UPDATE_ALL');
      var d = hasActionPermission(type, 'DELETE_ALL');
      var p = hasActionPermission(type, 'PERMISSION_ALL');

      var defer = $q.defer();

      $q.all([u, d, p]).then(function (res) {
        var objectPerm = {
          'UPDATE': res[0],
          'DELETE': res[1],
          'PERMISSION': [2]
        };
        if (!objectPerm.UPDATE || !objectPerm.DELETE || !objectPerm.PERMISSION) {
          Restangular.one('permissions', objectId).customGET('my-permissions').then(function (perm) {
            objectPerm.UPDATE = perm.UPDATE || objectPerm.UPDATE;
            objectPerm.DELETE = perm.DELETE || objectPerm.DELETE;
            objectPerm.PERMISSION = perm.PERMISSION || objectPerm.PERMISSION;
            defer.resolve(objectPerm);
          });
        } else {
          defer.resolve(objectPerm);
        }
      });

      return defer.promise;
    };

    var getUser = function () {
      if (angular.isDefined(user)) {
        return $q.when(user);
      } else {
        return userPromise;
      }
    };

    return {
      user: getUser,
      hasRole: function (role) {
        if (angular.isDefined(user)) {
          return $q.when(isAdmin || _.includes(user.allRolesNames, role));
        } else {
          var d = $q.defer();
          userPromise.then(function () {
            d.resolve(_.includes(isAdmin || user.allRolesNames, role));
          });
          return d.promise;
        }
      },
      hasActionPermission: function (type, permission) {

        if (angular.isDefined(user)) {
          return $q.when(hasActionPermission(type, permission));
        } else {
          var d = $q.defer();
          userPromise.then(function () {
            d.resolve(hasActionPermission(type, permission));
          });
          return d.promise;
        }
      },
      getObjectPermissions: function (type, objectId) {

        if (angular.isDefined(user)) {
          return getObjectPermissions(type, objectId);
        } else {
          var d = $q.defer();
          userPromise.then(function () {
            getObjectPermissions(type, objectId).then(function (res) {
              d.resolve(res);
            });
          });
          return d.promise;
        }
      }
    };
  })
  .controller('busyCtrl', function ($scope, $q, busyService) {

    var defer;
    busyService.bindListener({
      show: function (message) {
        if (angular.isObject(message)) {
          $scope.mo = message;
          $scope.$watch('mo.text', function () {
            $scope.message = $scope.mo.text;
          });
          $scope.message = $scope.mo.text;
        } else {
          $scope.message = message ? message : 'Proszę czekać...';
        }
        defer = $q.defer();
        $scope.busyPromise = defer.promise;

      },
      hide: function () {
        if (defer) {
          defer.resolve();
        }
        defer = undefined;
      }
    });
  })
  .factory('busyService', function () {
    var listener;
    return {
      bindListener: function (l) {
        listener = l;
      },
      show: function (message) {
        if (!listener) {
          throw 'No listener';
        }
        listener.show(message);
      },
      hide: function () {
        listener.hide();
      }
    };
  })
  .factory('emptyModifier', function () {
    return {
      makeValid: function () {
      },
      makeInvalid: function () {
      },
      makeDefault: function () {
      },
      key: 'emptyModifier'
    };
  })
  .factory('datetimePickerModifier', function () {
    var findFormGroup = function (elem) {
      var founded = elem;
      while (!founded.hasClass('form-group')) {
        founded = founded.parent();
        if (!founded) {
          break;
        }
      }
      return founded;
    };
    return {
      makeValid: function () {
      },
      makeInvalid: function (el, errorMsg) {
        var helpTextEl = angular.element('<span class="help-block has-error error-msg" style="position: absolute;top: 80px;left: 170px">' + errorMsg +
          '</span>');
        var group = findFormGroup(el);
        if (!group) {
          console.error('Not form group found');
        }
        var last = angular.element(_.last(group.children()));
        if (!last.hasClass('error-msg')) {
          last.after(helpTextEl);
          group.addClass('has-error');
        }
      },
      makeDefault: function (el) {
        var group = findFormGroup(el);
        if (!group) {
          console.error('Not form group found');
        }
        var message = angular.element(_.last(group.children()));
        if (message.hasClass('error-msg')) {
          group.removeClass('has-error');
          message.remove();
        }
      },
      key: 'datetimePickerModifier'
    };
  })
  .factory('customMessageModifier', function () {
    var findFormGroup = function (elem) {
      var founded = elem;
      while (!founded.hasClass('form-group')) {
        founded = founded.parent();
        if (!founded) {
          break;
        }
      }
      return founded;
    };
    return {
      makeValid: function () {
      },
      makeInvalid: function (el, errorMsg) {
        var group = findFormGroup(el);
        if (!group) {
          console.error('Not form group found');
        }
        group.addClass('has-error');
        var hits = group.find('span');
        angular.forEach(hits, function (item) {
          var e = angular.element(item);
          if (e.hasClass('error-msg')) {
            e.text(errorMsg);
            e.removeClass('hidden');
          }
        });
      },
      makeDefault: function (el) {
        var group = findFormGroup(el);
        if (!group) {
          console.error('Not form group found');
        }
        group.removeClass('has-error');
        var hits = group.find('span');
        angular.forEach(hits, function (item) {
          var e = angular.element(item);
          if (e.hasClass('error-msg')) {
            e.addClass('hidden');
          }
        });
      },
      key: 'customMessageModifier'
    };
  })
  .factory('viewsResolver', function (Restangular) {
    return {
      resolve: function (item) {
        if (item.viewsIds) {
          var ids;
          if (!angular.isArray(item.viewsIds)) {
            ids = [item.viewsIds];
          } else {
            ids = item.viewsIds;
          }
          if (ids.length === 1) {
            Restangular.one('views', ids[0]).get().then(function (view) {
              item.views = [view];
            });
          } else {
            Restangular.several('views', ids).getList().then(function (views) {
              item.views = views;
            });
          }
        }
      },
      toIds: function (item) {
        if (item.views) {
          var ids = [];
          angular.forEach(item.views, function (view) {
            ids.push(view.id);
          });
          item.viewsIds = ids;
          delete item.views;
        }
      }
    };
  })
  .factory('storesResolver', function (Restangular) {
    return {
      resolve: function (item) {
        if (item.storesIds) {
          var ids;
          if (!angular.isArray(item.storesIds)) {
            ids = [item.storesIds];
          } else {
            ids = item.storesIds;
          }
          if (ids.length === 1) {
            Restangular.one('stores', ids[0]).get().then(function (store) {
              item.stores = [store];
            });
          } else {
            Restangular.several('stores', ids).getList().then(function (stores) {
              item.stores = stores;
            });
          }
        }
      },
      toIds: function (item) {
        if (item.stores) {
          var ids = [];
          angular.forEach(item.stores, function (store) {
            ids.push(store.id);
          });
          item.storesIds = ids;
          delete item.stores;
        }
      }
    };
  })
  .factory('branchesResolver', function (Restangular) {
    return {
      resolve: function (item) {
        if (item.branchesIds) {
          var ids;
          if (!angular.isArray(item.branchesIds)) {
            ids = [item.branchesIds];
          } else {
            ids = item.branchesIds;
          }
          if (ids.length === 1) {
            Restangular.one('branches', ids[0]).get().then(function (branch) {
              item.branches = [branch];
            });
          } else {
            Restangular.several('branches', ids).getList().then(function (branches) {
              item.branches = branches;
            });
          }
        }
      },
      toIds: function (item) {
        if (item.branches) {
          var ids = [];
          angular.forEach(item.branches, function (branch) {
            ids.push(branch.id);
          });
          item.branchesIds = ids;
          delete item.branches;
        }
      }
    };
  })
  .factory('criteriaResolver', function (Restangular) {
    return {
      resolve: function (item) {
        if (item.criteriaIds) {
          var ids;
          if (!angular.isArray(item.criteriaIds)) {
            ids = [item.criteriaIds];
          } else {
            ids = item.criteriaIds;
          }
          if (ids.length === 1) {
            Restangular.one('criteria', ids[0]).get().then(function (criteria) {
              item.criteria = [criteria];
            });
          } else {
            Restangular.several('criteria', ids).getList().then(function (criteria) {
              item.criteria = criteria;
            });
          }
        }
      },
      toIds: function (item) {
        if (item.criteria) {
          var ids = [];
          angular.forEach(item.criteria, function (criteria) {
            ids.push(criteria.id);
          });
          item.criteriaIds = ids;
          delete item.criteria;
        }
      }
    };
  })
  .factory('deliveryResolver', function (Restangular) {
    return {
      resolve: function (item) {
        if (item.deliveriesIds) {
          var ids;
          if (!angular.isArray(item.deliveriesIds)) {
            ids = [item.deliveriesIds];
          } else {
            ids = item.deliveriesIds;
          }
          if (ids.length === 1) {
            Restangular.one('deliveries', ids[0]).get().then(function (deliveries) {
              item.deliveries = [deliveries];
            });
          } else {
            Restangular.several('deliveries', ids).getList().then(function (views) {
              item.deliveries = views;
            });
          }
        }
      },
      toIds: function (item) {
        if (item.deliveries) {
          var ids = [];
          angular.forEach(item.deliveries, function (delivery) {
            ids.push(delivery.id);
          });
          item.deliveriesIds = ids;
          delete item.deliveries;
        }
      }
    };
  })
  .factory('paymentResolver', function (Restangular) {
    return {
      resolve: function (item) {
        if (item.paymentsIds) {
          var ids;
          if (!angular.isArray(item.paymentsIds)) {
            ids = [item.paymentsIds];
          } else {
            ids = item.paymentsIds;
          }
          if (ids.length === 1) {
            Restangular.one('payments', ids[0]).get().then(function (payments) {
              item.payments = [payments];
            });
          } else {
            Restangular.several('payments', ids).getList().then(function (views) {
              item.payments = views;
            });
          }
        }
      },
      toIds: function (item) {
        if (item.payments) {
          var ids = [];
          angular.forEach(item.payments, function (payment) {
            ids.push(payment.id);
          });
          item.paymentsIds = ids;
          delete item.payments;
        }
      }
    };
  })
  .directive('form', function ($timeout) {
    return {
      require: 'form',
      restrict: 'E',
      link: function ($scope, $el, $attr, form) {
        form.manualSubmit = function () {
          $timeout(function () {
            $el.triggerHandler('submit');
          }, 0, false);
        };
      }
    };
  }).factory('RecursionHelper', ['$compile', function ($compile) {
  return {
    /**
     * Manually compiles the element, fixing the recursion loop.
     * @param element
     * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
     * @returns An object containing the linking functions.
     */
    compile: function (element, link) {
      // Normalize the link parameter
      if (angular.isFunction(link)) {
        link = {post: link};
      }

      // Break the recursion loop by removing the contents
      var contents = element.contents().remove();
      var compiledContents;
      return {
        pre: (link && link.pre) ? link.pre : null,
        /**
         * Compiles and re-adds the contents
         */
        post: function (scope, element) {
          // Compile the contents
          if (!compiledContents) {
            compiledContents = $compile(contents);
          }
          // Re-add the compiled contents to the element
          compiledContents(scope, function (clone) {
            element.append(clone);
          });

          // Call the post-linking function, if any
          if (link && link.post) {
            link.post.apply(null, arguments);
          }
        }
      };
    }
  };
}]);
